import { Add } from "@mui/icons-material";
import { Grid, Divider } from "@mui/material";
import AcxButton from "components/UI/AcxButton";
import { observer } from "mobx-react";
import { useStore } from "utils/useStore";
import { LLMClassifierBuilderStore } from "../../Stores/LLMClassifierBuilderStore";
import { useLogicChainConfigurationBuilder } from "../LLMConfigurationBuilderContext";
import { LLMModelSelector } from "../LLMModelSelector";
import React from "react";
import { Step } from "./Step";
import { LLMClassifierBuilderStepperStore } from "../../Stores/LLMClassifierBuilderStepperStore";

interface LogicChainBuilderProps {}

export const LogicChainBuilder = observer(function (
    props: LogicChainBuilderProps,
) {
    const store = useStore(LLMClassifierBuilderStore);
    const stepper = useStore(LLMClassifierBuilderStepperStore);
    const builder = useLogicChainConfigurationBuilder();

    return (
        <Grid container direction="column" rowGap={2}>
            <Grid container item columns={2} columnGap={2} flexWrap="nowrap">
                <Grid item xs={2}>
                    <LLMModelSelector
                        inputLabel="LLM Model"
                        required
                        defaultValue={store.classifier.implementation.llmModel}
                        infoText="This is the default LLM Model to use for all steps. You can override this on a per step basis but it is not required."
                        error={stepper.hasError.llmModelMissing}
                        onChange={(model) => {
                            store.classifier.implementation.setLLMModel(model);
                            stepper.resetError("llmModelMissing");
                        }}
                    />
                </Grid>
            </Grid>
            <Grid container direction="column" flexWrap="nowrap" rowGap={2}>
                {builder.steps.map((step) => (
                    <React.Fragment key={step.reactKey}>
                        <Grid item>
                            <Divider />
                        </Grid>
                        <Step
                            step={step}
                            defaultModel={store.classifier.implementation.llmModel}
                        />
                    </React.Fragment>
                ))}
                <Grid item>
                    <Divider />
                </Grid>
                <Grid item>
                    <AcxButton
                        color="white"
                        sx={(theme) => ({ color: theme.palette.primary.main })}
                        startIcon={<Add />}
                        onClick={() => builder.addStep()}
                    >
                        Step
                    </AcxButton>
                </Grid>
            </Grid>
        </Grid>
    );
});
